import { defineMessages } from '@/i18n';

export const inventoryItemEditionsMessages = defineMessages({
  uniqueLabel: 'platform.app.inventory.createItem.editionsUniqueLabel',
  editionsLabel: 'platform.app.inventory.createItem.editionsEditionsLabel',
  noteContent: 'platform.app.inventory.createItem.editionsNoteContent',
  noteTitle: 'platform.app.inventory.createItem.editionsNoteTitle',
  retailPriceDescription: 'platform.app.inventory.createItem.editionsRetailPriceDescription',
  volumeAllLabel: 'platform.app.inventory.createItem.editionsVolumeAllLabel',
  volumeNoneLabel: 'platform.app.inventory.createItem.editionsVolumeNoneLabel',
  volumeCustomLabel: 'platform.app.inventory.createItem.editionsVolumeCustomLabel',
  addLabel: 'platform.app.inventory.createItem.editionsAddLabel',
  volumeSelectionPlaceholder: 'platform.app.inventory.createItem.editionsVolumeSelectionPlaceholder',
  customSelectionPlaceholder: 'platform.app.inventory.createItem.editionsCustomSelectionPlaceholder',
  editionSelectorLabel: 'platform.app.inventory.createItem.editionsEditionSelectorLabel',
  apSelectorLabel: 'platform.app.inventory.createItem.editionsApSelectorLabel',
  invalidCustomSelectionOutOfBounds: 'platform.app.inventory.createItem.editionsInvalidCustomSelectionOutOfBounds',
  volumeOutOfBoundsEditions: 'platform.app.inventory.createItem.editionsVolumeOutOfBoundsEditions',
  volumeEmptyEditions: 'platform.app.inventory.createItem.editionsVolumeEmptyEditions',
  volumeOutOfBoundsAps: 'platform.app.inventory.createItem.editionsVolumeOutOfBoundsAps',
  volumeEmptyAps: 'platform.app.inventory.createItem.editionsVolumeEmptyAps',
  customSelectionEmptyEditions: 'platform.app.inventory.createItem.editionsCustomSelectionEmptyEditions',
  customSelectionEmptyAps: 'platform.app.inventory.createItem.editionsCustomSelectionEmptyAps',
  bothEmpty: 'platform.app.inventory.createItem.editionsBothEmpty',
  noMoreEditionsToAdd: 'platform.app.inventory.createItem.editionsNoMoreEditionsToAdd',
});
